module.exports = __webpack_public_path__ + "img/denmark-lung-cancer-male.4b41af5a.png";